import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04111c0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-td" }
const _hoisted_2 = {
  key: 0,
  class: "td_free_box"
}
const _hoisted_3 = { key: 1 }


import { Popover } from 'ant-design-vue';
import { QuestionCircleFilled, CheckOutlined, CloseOutlined } from '@ant-design/icons-vue';
import type { CellItem } from '../types';
interface Props {
  nodeData: CellItem[];
  show?: boolean;
}

const __default__ = { name: 'NextTd' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    nodeData: null,
    show: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  nodeData: CellItem[];
  show?: boolean;
};

const aPopover = Popover;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.nodeData, (item, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["td_item", item.res || item.free ? 'on' : '']),
        key: index,
        style: _normalizeStyle({ borderBottom: !props.show ? 'none' : '' })
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["td_item_text", item.free && item.res === '×' ? 'free' : ''])
        }, [
          _createTextVNode(_toDisplayString(item.name) + " ", 1),
          (item.tips)
            ? (_openBlock(), _createBlock(_unref(aPopover), {
                key: 0,
                placement: "right"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createElementVNode("pre", null, _toDisplayString(item.tips), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionCircleFilled))
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ], 2),
        (item.free && item.res === '×')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "限时免费"))
          : (item.res !== '×' && item.res !== '√')
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.res), 1))
            : (item.res !== '×')
              ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                  key: 2,
                  class: "suc"
                }))
              : (_openBlock(), _createBlock(_unref(CloseOutlined), {
                  key: 3,
                  class: "err"
                }))
      ], 6)), [
        [_vShow, props.show ? true : index === 0]
      ])
    }), 128))
  ]))
}
}

})